
import { defineComponent, PropType } from "vue";

import Star from "@/components/svg/Star.vue";
import Checkmark from "@/components/svg/Checkmark.vue";
import { Translations } from "@/entities/domain/Translations";
import QuizService from "@/services/QuizService";
import FeedbackOverlay from "../BaseComponents/FeedbackOverlay.vue";
import Company from "@/entities/domain/Company/Company";

export default defineComponent({
	name: "FeedbackStars",
	components: { Star, Checkmark, FeedbackOverlay },
	props: {
		company:{
			type: Object as PropType<Company>,
			required: true
		},
		baseComponentTranslations: {
			type: Object as PropType<Translations>,
			required: true,
		},
		visible: Boolean,
	},
	data() {
		return {
			review: null as number | null,
			preview: 5 as number | null,
			showQuestion: false,
			sended: false,
			isOverlayVisble: false,
		};
	},
	mounted() {
		setTimeout(() => {
			this.showQuestion = true;
		}, 5000);
	},
	methods: {
		onMinorRatingCauseSelected(minorRatingCause: string) {
			this.sendReview(minorRatingCause);
		},
		async sendReview(cause) {
			if (this.review === null) return;


			if (this.review && this.review <= 3 && !this.isOverlayVisble) {
				this.isOverlayVisble = true;
			} else {
				this.isOverlayVisble = false;
				this.sended = true;
				await QuizService.sendEvent(JSON.stringify({ rating: this.review, cause: cause }), "feedback");
				// if (cause)
				//   await QuizService.sendEvent(cause, "feedbackCause");
				setTimeout(() => {
					this.showQuestion = false;
				}, 3000);
			}
		},
	},
	computed: {
		possibleFeedbackReasons() {
			return [
				{
					Title: this.company.DisplayedTexts['Produktauswahl'],
					Value: 'productSelection',
					SubSelection: [
						{
							Title: this.company.DisplayedTexts['Typ'],
							Value: 'productType',
						},
						{
							Title: this.company.DisplayedTexts['Preis'],
							Value: 'productPrice',
						},
					]
				},
				{
					Title: this.company.DisplayedTexts['Dauer'],
					Value: 'duration'
				},
				{
					Title: this.company.DisplayedTexts['Fragen'],
					Value: 'questions'
				}
			];
		}
	}
});
